import { Button } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import DocumentUploadForm from 'modules/box-strorage/components/DocumentUploadForm/DocumentUploadForm';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const DocumentUploadPage = () => {
    return (
        <PageTemplate>
            <PageHeading className="">
                <div>
                    <BackButton to={'/box-storage'} />
                </div>

                <div className="mt-2">Upload Box Storage</div>
            </PageHeading>
            <DocumentUploadForm />
        </PageTemplate>
    );
};

export default DocumentUploadPage;
